/** Modulo 1: encomendas. */
export const PACKAGE_STATUSES = [
    'awaiting',
    'picked_up',
    'returned',
    'expired',
    /**
     * Registro desfeito pela portaria — unidade errada, etiqueta lida duas
     * vezes, caixa que nem era encomenda.
     *
     * E um estado, e nao a ausencia da linha, porque a encomenda cancelada
     * precisa continuar respondendo "o que aconteceu com o #PKG-8F2K que voces
     * me mandaram no WhatsApp ontem?". Ver a migration 0011.
     */
    'canceled',
];
export const PACKAGE_STATUS_LABELS = {
    awaiting: 'Aguardando',
    picked_up: 'Retirada',
    returned: 'Devolvida',
    expired: 'Expirada',
    canceled: 'Cancelada',
};
export const PACKAGE_CONDITIONS = ['normal', 'damaged', 'opened', 'wet'];
export const PACKAGE_CONDITION_LABELS = {
    normal: 'Normal',
    damaged: 'Avariada',
    opened: 'Violada',
    wet: 'Molhada',
};
/**
 * Teto de caixas num registro.
 *
 * Nao e limite tecnico — e o tamanho de um carrinho de portaria. O numero
 * existe porque a quantidade e digitada com a caixa na mao e um "30" no lugar
 * de "3" consumiria trinta encomendas da cota do plano de uma vez, sem que
 * nada parecesse errado na tela.
 */
export const MAX_PACKAGE_BATCH = 20;
/**
 * Alfabeto do codigo curto — sem 0/O/1/I/L, que sao os pares que se confundem
 * quando o porteiro dita o codigo por telefone ou pelo interfone.
 *
 * Mora no shared, e nao ao lado do gerador no backend, porque quem **le** o
 * codigo digitado precisa da mesma lista: se o gerador ganhasse uma letra e o
 * parser nao, a portaria receberia "codigo invalido" para um codigo que o
 * proprio sistema imprimiu.
 */
export const PACKAGE_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
/**
 * O codigo de exemplo mostrado ao porteiro — na mensagem de erro da API e no
 * campo da tela de retirada.
 *
 * Existe como constante, e nao como texto solto em cada lugar, porque um
 * exemplo tem de ser um codigo VALIDO: o exemplo antigo era "PKG-8F21", que o
 * proprio sistema recusa (o alfabeto nao tem "1"). Quem digitasse exatamente o
 * que a tela sugeria recebia "codigo invalido" — e concluia que o produto
 * estava quebrado. Ha teste garantindo que este valor passa por
 * `parsePackageCode`.
 */
export const PACKAGE_CODE_EXAMPLE = 'PKG-8F2K';
const PACKAGE_CODE_RE = new RegExp(`^[${PACKAGE_CODE_ALPHABET}]{4}$`);
/**
 * Normaliza o que o porteiro digitou para o formato canonico "PKG-8F2K", ou
 * `null` se aquilo nao e um codigo de encomenda.
 *
 * Aceita com ou sem prefixo, com ou sem hifen, minusculo, com o "#" que a tela
 * mostra na frente — tudo isso e a mesma encomenda, e recusar por causa da
 * forma seria trocar um atrito de balcao por uma regra de digitacao.
 */
export function parsePackageCode(value) {
    const digits = value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .replace(/^PKG/, '');
    return PACKAGE_CODE_RE.test(digits) ? `PKG-${digits}` : null;
}
export const PACKAGE_EVENT_TYPES = [
    'registered',
    'notified',
    'notification_failed',
    'qr_validated',
    'delivered',
    'returned',
    'note',
    'signed',
    'photographed',
    'canceled',
];
export const PACKAGE_EVENT_LABELS = {
    registered: 'Encomenda registrada',
    notified: 'Morador notificado',
    notification_failed: 'Falha ao notificar',
    qr_validated: 'QR validado',
    delivered: 'Entrega confirmada',
    returned: 'Encomenda devolvida',
    note: 'Observacao',
    signed: 'Assinatura coletada',
    photographed: 'Foto anexada',
    canceled: 'Registro cancelado',
};
export const PICKUP_METHODS = ['qr', 'code'];
//# sourceMappingURL=packages.js.map